<ng-container *ngIf="color">
  <ng-container [ngSwitch]="color">
    <div *ngSwitchCase="'multi'" class="border-grayTableBorder rounded border rainbow-background"
         style="height: 26px; width: 26px;"></div>
    <div class="border-grayTableBorder rounded border" style="height: 26px; width: 26px;" [style.background]="color"
         *ngSwitchDefault>
    </div>
  </ng-container>
</ng-container>
